/**
 * Cards every new player owns.
 * Matches the campaign Mission 1 teaching loadout so campaign + endless share one start.
 */
export const STARTER_OWNED_IDS: readonly string[] = [
  "heb-11-1",
  "mark-11-22",
  "eph-6-16",
  "ps-46-10",
  "phil-4-6-7",
  "thess-5-17",
];

/** Soft ceiling on copies of any one verse. */
export const MAX_COPIES = 4;
